/* global $ */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './UploadsOkModalVideoLlamada.css';

class UploadsOkModalVideoLlamada extends React.Component {
  static closeUploadsOk() {
    $('#modalVideoLlamadaUploadsOk').hide(200);
    $('#modalVideoLlamadaUploads').show(200);
  }

  componentDidMount() {}

  componentWillReceiveProps() {}

  componentWillUnmount() {}

  render() {
    return (
      <div
        className={s.modalVideoLlamadaUploadsOk}
        id="modalVideoLlamadaUploadsOk"
      >
        <span
          id="boton_cerrar"
          style={{
            position: 'absolute',
            right: '10px',
            top: '0',
            fontWeight: 'bold',
            color: '#000',
          }}
          role="button"
          tabIndex="-1"
          onClick={UploadsOkModalVideoLlamada.closeUploadsOk}
        >
          x
        </span>
        <div className="row col-12" style={{ padding: '0' }}>
          <i
            className="fa fa-picture-o col-2"
            aria-hidden="true"
            style={{
              fontSize: '34px',
              textAlign: 'center',
            }}
          />
          <div
            className="col-10"
            style={{ fontSize: '20px', lineHeight: '20px' }}
          >
            Tus archivos se han enviado correctamente.
          </div>
        </div>
      </div>
    );
  }
}
/*
const mapStateToProps = state => ({
  fileuploadStatus: state.telemedicina.fileuploadStatus,
});
*/
export default withStyles(s)(UploadsOkModalVideoLlamada);



// WEBPACK FOOTER //
// ./src/components/Telemedicina/ModalVideoLlamada/UploadsOkModalVideoLlamada/UploadsOkModalVideoLlamada.js